export { default } from './RandomTeamPage';
